export enum WinState {
    None,
    Win,
    Lose,
    Push,
    Surrender,
}

export enum PairResult {
    PairNone,
    PairMixed,
    PairColored,
    PairPerfect,
    PairSuitedTrips,
}
